import { render } from "./TransportationTicketComponent.vue?vue&type=template&id=751505ee&scoped=true&ts=true"
import script from "./TransportationTicketComponent.vue?vue&type=script&lang=ts"
export * from "./TransportationTicketComponent.vue?vue&type=script&lang=ts"

import "./TransportationTicketComponent.vue?vue&type=style&index=0&id=751505ee&scoped=true&lang=scss"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751505ee"]])

export default __exports__